module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-nissan.32610d3b.png";